import React from 'react';

const Unauthorized = () => {
    return (
        <h3>502 - Not Allowed</h3>
    );
};

export default Unauthorized;
